/* unplugin-vue-components disabled */import script from "./H5LocaleSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./H5LocaleSheet.vue?vue&type=script&setup=true&lang=js"

import "./H5LocaleSheet.vue?vue&type=style&index=0&id=47867b41&scoped=true&lang=scss"
import "./H5LocaleSheet.vue?vue&type=style&index=1&id=47867b41&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47867b41"]])

export default __exports__